import React, { useEffect } from "react"
import { connect } from "react-redux"
import { Grid } from "react-flexbox-grid"
import { withRouter } from "react-router-dom"
import * as RegionStatisticsActions from "../actions/regionStatisticsActions"
import Styles from "./Main.module.css"
import Metrics from "../components/Metrics/Metrics"
import { Seo } from "../components/Seo"

const Main = props => {
  const { regionStatistics } = props

  useEffect(() => {
    props.fetchRegionStats()
  }, [])

  return (
    <React.Fragment>
      <Grid fluid className={Styles.pageContent}>
        <Metrics statistics={regionStatistics} />
        <p className={Styles.infoText}>
          Tutustu tarkemmin yritystietoihin <a className={Styles.infoLink} href="https://businesstampere.com/business-tampere-data/#yritysten-elinvoima">Yritysten elinvoima -tietopalvelusta</a>.
        </p>
      </Grid>
      <Seo />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  loadingRegionStatistics: state.regionStatistics.loading,
  regionStatistics: state.regionStatistics.data
})

const mapDispatchToProps = dispatch => ({
  fetchRegionStats: () => dispatch(RegionStatisticsActions.fetchRegionStatistics())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main))
